import { combineReducers } from 'redux';
import { globalReducer } from './modules/App/reducer';
import { mainPageReducer } from './modules/MainPage/reducer';
import { newsEventPageReducer } from './modules/NewsEventPage/reducer';



export const appReducer = combineReducers({
    app: globalReducer,
    mainPage: mainPageReducer,
    newsEventPage: newsEventPageReducer,
});
